import type { ReactNode } from 'react'
import { colors } from 'settings/colors'

// Centered notice for a card body with nothing to show: no access, no data, or a failed fetch.
export const DashboardMessage = ({ children }: { children: ReactNode }) => (
  <div
    css={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      minHeight: 80,
      padding: 16,
      color: colors.grey800,
      fontSize: 14,
    }}
  >
    {children}
  </div>
)
